<template>
  <v-col :cols="cols">
    <div class="d-flex align-center pr-3">
      <v-text-field
        :value="value"
        :placeholder="placeholder"
        dense
        outlined
        hide-details
        clearable
        @input="$emit('input', $event)"
        @keyup.enter="$emit('search')"
      >
      </v-text-field>
      <v-card
        flat
        tile
        color="grey lighten-3"
        class="d-flex align-center rounded-r"
        style="cursor: pointer; outline: 1px solid gray; padding: 7px 12px"
        @click="$emit('search')"
      >
        <v-icon color="primary">mdi-magnify</v-icon>
      </v-card>
    </div>
  </v-col>
</template>

<script>
export default {
  name: "CampoPesquisa",
  props: {
    value: { type: String, default: "" },
    placeholder: { type: String, default: "Buscar..." },
    cols: { type: [String, Number], default: 4 },
  },
};
</script>

<style scoped></style>
